import { IColumn } from "@fluentui/react";
import PagedList from "../../common/PagedList";
import { IPagedCollection } from "../../services/assetServices";
import { gql } from "@apollo/client";
import { client } from "../../services/apolloClient";

export const ActivityLogList = () => {
  const pageSize = 10;

  interface IActivityLog {
    loggedAt: string;
    username: string;
    action: string;
    summary: string;
  }

  const GET_ACTIVITY_LOGS = gql`
  query GetActivityLogs($limit: Int!, $offset: Int!, $search: String) {
    activityLogs(limit: $limit, offset: $offset, search: $search) {
      nodes {
        id
        loggedAt
        username
        action
        summary
      }
      pageInfo {
        hasNextPage
      }
      totalCount
    }
  }
`;

  const getAction = async (abortController: AbortController, pageSize: number, pageNo: number,
    _orderBy?: string, search?: string) => {
    const { data } = await client.query({
      query: GET_ACTIVITY_LOGS,
      variables: {
        limit: pageSize,
        offset: (pageNo - 1) * pageSize,
        search: search || "",
      },
      context: { fetchOptions: { signal: abortController.signal } },
      fetchPolicy: 'network-only',
    });

    return {
      isLastPage: !data.activityLogs.pageInfo.hasNextPage,
      items: data.activityLogs.nodes,
      pageCount: Math.ceil(data.activityLogs.totalCount / pageSize),
      pageNo,
      pageSize,
      rowsCount: data.activityLogs.totalCount,
    };
  }

  const columns: IColumn[] = [
    { key: 'loggedAt', name: 'Time', fieldName: 'loggedAt', minWidth: 100 },
    { key: 'username', name: 'User', fieldName: 'username', minWidth: 100 },
    { key: 'action', name: 'Action', fieldName: 'action', minWidth: 100 },
    { key: 'summary', name: 'Summary', fieldName: 'summary', minWidth: 200 },
  ];

  return (
    <PagedList
      selectedTab="activity"
      columns={columns}
      commandBarItems={[]}
      getAction={getAction}
      pageSize={pageSize}
    />
  );
};
